//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      showMoveDot: false,
      startX: 0,
      startY: 0,
      endX: window.innerWidth - 180,
      endY: 20,
      onFinished: null
    }
  },
  mounted() {
    this.showMoveDot = true
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 1
      el.style.webkitTransform = "translate3d(0, 0, 0)" //接着将小球位置置为初始值，但css中设置了transition .8s,因此，动画效果就出来了
      el.style.transform = "translate3d(0, 0, 0)"
      let inner = el.children[0]
      inner.style.webkitTransform = "translate3d(0, 0, 0)"
      inner.style.transform = "translate3d(0, 0, 0)"
      el.style.transition = "all 1.2s cubic-bezier(0.42, 0, 0.54, 0.84)"
      inner.style.transition = "all 1.2s"
    },
    enter(el, done) {
      // 打开offsetWidth 触发浏览器重绘
      el.offsetWidth
      // 设置相对结束位置
      const xDist = this.endX - this.startX
      const yDist = this.endY - this.startY

      el.style.webkitTransform = `translate3d(0, ${yDist}px, 0px)`
      el.style.transform = `translate3d(0, ${yDist}px, 0px)`
      let inner = el.children[0]
      inner.style.webkitTransform = `translate3d(${xDist}px, 0, 0)`
      inner.style.transform = `translate3d(${xDist}px, 0, 0)`
      el.style.transition = "all 1.2s cubic-bezier(0.42, 0, 0.54, 0.84)"
      inner.style.transition = "all 1.2s"
      done()
      this.showMoveDot = false
    },
    afterEnter(el) {
      // 设置透明度
      el.style.opacity = 1
    },
    handleAfterLeave() {
      if (typeof this.onFinished === "function") {
        this.onFinished(this)
      }
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
